<template lang="pug">
    m-form(ref="form" class="m-form-object-trades")

        template(#content-template="")
            v-flex(class="container-responsive")
                m-block-form-fields(:tooltip="$t(`modules.blocks.${name}.tooltip`)" child required)
                    template(#title="") {{$t(`modules.forms.${name}.blocks.business-type`)}}

                    v-layout(wrap)
                        v-flex(sm12 md10)
                            e-input-object-business-types(
                                :items="orgBusinessTypes"
                                v-model="form.businessTypes"
                                :disabled="!canEdit"
                                t="e-input-select-org-business-types"
                                :innerTooltip="true"
                                )
                        v-flex(sm12 md2)
                            m-list-business-types-logo(:class="logoClasses")

                m-block-form-fields(child v-if="showSelectModeratorField")
                    template(#title="") {{$t(`modules.forms.${name}.blocks.competent-persons`)}}

                    e-input-object-competent-persons(
                        v-if="showSelectModeratorField"
                        v-model="form.moderators"
                        ref="persons"
                        :disabled="!canEdit"
                        :innerTooltip="true"
                    )

        template(#buttons="" v-if="!isOnboarding")
</template>

<script>
    import baseForm from "@mixins/components/modules/forms/base";
    import customValidation from "@mixins/validation/_custom";
    import dialogs from '@mixins/includes/_dialogs';
    import {mapActions, mapGetters} from 'vuex';
    import MListBusinessTypesLogo  from "@components/modules/lists/concrete/m-list-business-types-logo";
    import MTooltipInfo from "../../../tooltips/concrete/m-tooltip-info";

    let name = 'm-form-object-trades';

    export default {
        name: name,
        mixins: [baseForm, customValidation, dialogs],
        props: {
            name: {
                type: String,
                default: name
            },
            isOnboarding: {
                type: Boolean,
                default: false
            }
        },
        components: {MTooltipInfo, MListBusinessTypesLogo},
        created() {
            this.getBusinessTypes({
                id: this.$user.relationships.organization.data.id
            })
            .then(res => {
                if (!this.objectBusinessType) return

                let businessTypesIds = this.objectBusinessType.map(v => v.id);

                this.form.businessTypes = this.$form.objectToArray(this.$lodash.pick(res, businessTypesIds));
            });
            this.getSuggestedUsers({orgId: this.$user.relationships.organization.data.id}).then(()=>{
                if(this.$lodash.isEmpty(this.suggestedUsers)){
                    this.showSelectModeratorField = false
                    return
                }
                // for moderators selected by default. Used on edit stepper
                if (this.objectModerators.length) {
                    let moderatorIds = this.objectModerators.map(moderator => moderator.id)

                    this.form.moderators = this.suggestedUsers.filter(suggestedUser => moderatorIds.indexOf(suggestedUser._jv.id) !== -1)
                }
            })
        },
        data: () => ({
            form: {
                businessTypes: null,
                moderators: []
            },
            showSelectModeratorField: true
        }),
        computed: {
            ...mapGetters({
                getOrgBusinessTypes: 'organizations/business_types',
                suggestedUsers: 'organizations/suggested_users',
                getObject: 'objects/read',
            }),

            object() {
                return this.$route.params.id ? this.getObject(this.$route.params.id) : null;
            },
            objectBusinessType() {
                if (this.$lodash.isEmpty(this.object) || this.$lodash.isEmpty(this.object._jv.relationships.businessType)) return null
                return this.object._jv.relationships.businessType.data
            },
            objectModerators() {
                if (this.$lodash.isEmpty(this.object) || this.$lodash.isEmpty(this.object._jv.relationships.moderators)) return []
                return this.object._jv.relationships.moderators.data
            },

            orgBusinessTypes() {
                return this.getOrgBusinessTypes
            },

            canEdit() {
                if (this.$lodash.isEmpty(this.object)) return true
                return this.$can(this.$actions.update, this.$subjects.objects.key)
            },
            logoClasses() {
                return [
                    'mb-2',
                    {
                        'pt-4': !this.breakpoints.isLessThanTablet
                    }
                ];
            }

        },
        methods: {
            ...mapActions({
                getBusinessTypes: 'organizations/business_types',
                getSuggestedUsers: 'organizations/search_users'
            }),

            submit() {
                this.$validator.validateAll().then((success) => {
                    if (success) {
                        if(!this.$lodash.isEmpty(this.form.moderators) || !this.showSelectModeratorField) {
                            this.$emit('form:submit', this.form);
                            return;
                        }
                        this.openDialog({
                            type: 'objectEmptyCompetentPersons',
                        }).then((res) => {
                            if (res) {
                                this.$emit('form:submit', this.form);
                            }
                        });
                    } else {
                        const el = document.querySelector(".v-messages__message");
                        el.scrollIntoView({behavior: "smooth" ,block: "center"});
                        this.notify.error(this.$t('notifications.errors.formErrors.invalid'))
                    }
                });
            },

            cancel() {
                if (!this.$can(this.$actions.update, this.$subjects.objects.key)) return
                this.$emit('form:cancel', this.form);
            }
        }
    }
</script>

<style lang="scss">
    .container-responsive {
        @include media(md) {
            padding-left: 0 !important;
        }
    }
    .m-form-object-trades {
        padding: 0 0 0 1rem !important;

        @media (max-width: $md) {
            padding: 0 !important;
        }

        .v-divider {
            display: none;
        }
    }
    .fullscreen {
        .m-form-object-types {
            padding: 0 !important;
        }
    }
    .m-form-object-trades__tooltip-wrap {

    }

</style>
